import script from "./BDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./BDialog.vue?vue&type=script&lang=ts&setup=true"

import "./BDialog.vue?vue&type=style&index=0&id=c76d29a8&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c76d29a8"]])

export default __exports__